module.exports = __webpack_public_path__ + "c68038be46c4252339dc7f7077dfbeeb.png";